import React from 'react'

export default function HomeBody() {
  return (
    <div className="bg-black py-4">
      <div className="w-[85%] mx-auto container max-w-[1100px] text-white text-center relative top-[-2rem] font-medium md:top-[0rem] md:w-[90%] md:mx-auto ">
        <p className="md:text-[20px]">
          <em>
            <strong>Award - Winning Dorothy Dandridge! The Musical</strong>
          </em>{' '}
          is a joyous, spectacular, song and dance celebration of a fearless
          pioneer who dared to dream! As she intones in the rousing final
          number, "For all the kings and queens and in-betweens crowding round
          my door... pity me not." Dorothy Jean Dandridge, a beautiful,
          ambitious, and talented African-American girl from Ohio, dreams of
          lighting up the stage and silver screen in the 1950s. When she finally
          gets her "big break" in Hollywood, she inherits the challenges of a
          leading black woman! The show breaks new ground as it unites the story
          of one of the most acclaimed actresses of our time, set to an
          innovative, contemporary, genre-crossing original score. This hotly
          anticipated and bold production, presented by an award-winning
          Broadway and Hollywood team, premiered at Carnegie Hall in July 2022!
        </p>
        <div className="mt-4">
          <p className="pb-[1px] md:text-[20px]">
            <strong className="block font-extrabold	 md:inline-block">
              DIRECTED BY
            </strong>{' '}
            TAMARA TUNIE
          </p>
          <p className="pb-[1px] md:text-[20px]">
            <strong className="block font-extrabold	 md:inline-block">
              PRODUCED BY
            </strong>{' '}
            RICHARD BELL &amp; N'KENGE
          </p>
          <p className="pb-[1px] md:text-[20px]">
            <strong className="block font-extrabold	 md:inline-block">
              BOOK &amp; LYRICS BY
            </strong>{' '}
            TREY ELLIS
          </p>
          <p className="pb-[1px] md:text-[20px]">
            <strong className="block font-extrabold	 md:inline-block">
              MUSIC &amp; LYRICS BY
            </strong>{' '}
            SHELTON L. BECTON
          </p>
          <p className="pb-[1px] md:text-[20px]">
            <strong className="block font-extrabold uppercase	 md:inline-block">
              Choreography BY
            </strong>{' '}
            BYRON EASLEY
          </p>
          <p className="pb-[1px] md:text-[20px]">
            <strong className="block font-extrabold	 md:inline-block">
              CONCEIVED BY
            </strong>{' '}
            N&rsquo;KENGE
          </p>
          <p className="pb-[1px] md:text-[20px]">
            <strong className="block font-extrabold	 md:inline-block">
              ARRANGEMENTS BY
            </strong>{' '}
            EVERETT BRADLEY
          </p>
        </div>
      </div>
    </div>
  )
}
